import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

export default class LegalAgreementsRequest extends CrudRequest {
  static baseUrl() {
    return 'backofficeapi/legal-agreements';
  }

  static download(id) {
    return httpService.get(
      `${this.baseUrl()}/download/${id}`,
      {
        responseType: 'blob',
        params: {
          format: 'pdf',
        },
      },
    );
  }

  static downloadLatestTermsOfUse() {
    return this.makeDownloadBaseLatest('terms-of-use');
  }

  static downloadLatestPrivacyPolicy() {
    return this.makeDownloadBaseLatest('privacy-policy');
  }

  static downloadLatestContract() {
    return this.makeDownloadBaseLatest('contract');
  }

  static makeDownloadBaseLatest(type) {
    return httpService.get(
      `${this.baseUrl()}/download/latest/${type}`,
      {
        responseType: 'blob',
        params: {
          format: 'pdf',
        },
      },
    );
  }
}
